module.exports = __webpack_public_path__ + "img/itStatement.831708fd.svg";